import { X } from "lucide-react";
import { useUIStore } from "@/stores/ui-store";
import { StudyInspector } from "@/components/clinical/StudyInspector";
import { SiteInspector } from "@/components/clinical/SiteInspector";
import { SubjectInspector } from "@/components/clinical/SubjectInspector";
import { QueryInspector } from "@/components/clinical/QueryInspector";
import { ConnectionInspector } from "@/components/integrations/ConnectionInspector";
import { AlertInspector } from "@/components/alerts/AlertInspector";
import { AlertRuleInspector } from "@/components/alerts/AlertRuleInspector";
import { EventInspector } from "@/components/calendar/EventInspector";
import { UserInspector } from "@/components/users/UserInspector";
import { AuditEntryInspector } from "@/components/audit/AuditEntryInspector";
import { StudyBuildInspector } from "@/components/study-builder/StudyBuildInspector";
import { StudyBuildDetailInspector } from "@/components/study-builder/StudyBuildDetailInspector";

export function InspectorPanel() {
  const { inspectorContent, closeInspector } = useUIStore();

  if (!inspectorContent) {
    return (
      <div data-testid="inspector-panel" className="flex h-full items-center justify-center text-sm text-muted-foreground">
        Select an item to view details
      </div>
    );
  }

  return (
    <div data-testid="inspector-panel" className="flex h-full flex-col">
      <div className="flex items-center justify-between border-b border-border px-4 py-2">
        <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
          Details
        </span>
        <button
          data-testid="inspector-close"
          onClick={closeInspector}
          className="rounded p-1 text-muted-foreground hover:bg-muted hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-4">
        {inspectorContent.type === "study" && <StudyInspector data={inspectorContent.data} />}
        {inspectorContent.type === "site" && <SiteInspector data={inspectorContent.data} />}
        {inspectorContent.type === "subject" && <SubjectInspector data={inspectorContent.data} />}
        {inspectorContent.type === "query" && <QueryInspector data={inspectorContent.data} />}
        {inspectorContent.type === "connection" && <ConnectionInspector data={inspectorContent.data} />}
        {inspectorContent.type === "alert" && <AlertInspector data={inspectorContent.data} />}
        {inspectorContent.type === "alertRule" && <AlertRuleInspector data={inspectorContent.data} />}
        {inspectorContent.type === "event" && <EventInspector data={inspectorContent.data} />}
        {inspectorContent.type === "user" && <UserInspector data={inspectorContent.data} />}
        {inspectorContent.type === "auditEntry" && <AuditEntryInspector data={inspectorContent.data} />}
        {inspectorContent.type === "studyBuild" && <StudyBuildInspector />}
        {inspectorContent.type === "studyBuildDetail" && <StudyBuildDetailInspector />}
      </div>
    </div>
  );
}
